/* eslint-disable @typescript-eslint/naming-convention */
import type { PassThrough } from "@primevue/core";
import { SelectPassThroughOptions } from "primevue/select";

export const getDropdownPtOptions = (
    inputClasses: string[],
    dataTest: string,
    dataTestid?: string
): PassThrough<SelectPassThroughOptions> => {
    return {
        root: (options) => ({
            class: ["ds-dropdown__select", { "is-dropdown-open": options.state.overlayVisible }],
            "data-test": dataTest,
        }),
        label: (options) => ({
            active: options.state.overlayVisible,
            class: ["ds-dropdown__select-label", inputClasses],
            "data-test": dataTest ? dataTest + "-label" : null,
            "data-testid": dataTestid,
        }),

        dropdown: "ds-dropdown__select-icon",
        overlay: "ds-dropdown__overlay",
        listContainer: "ds-dropdown__overlay-container",
        virtualScroller: {
            root: "ds-dropdown__overlay-scroller",
        },
        list: { class: "ds-dropdown__overlay-list", "data-test": "dropdown-options" },
        option: () => ({
            class: ["ds-dropdown__option"],
            "data-test": "dropdown-option",
        }),
        transition: {
            name: "ds-dropdown-overlay",
        },
    };
};
